import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
     jcrewPrivacyPolicy: string;
     footerOne: string;
     footerTwo: string;
     lastFooter: string;
     step:{
         personalInfo:{
            birthDate:string;
         };
        docUpload:{
            redirectText1: string;
            acceptableExamples: string;
            uploadDocNoFileSelected: string;
            uploadDocDocScan: string;
            FooterOne: string;
            FooterTwo: string;
            uploadDocFirstName: string;
            uploadDocLastName:string;
            uploadDocOrganization:string;
            uploadDocAffiliation: string;
            uploadDocStatus: string;
        };
        success:{
            returnTo: string;
            useDiscount: string;
            footerThree: string;
        };
        pending:{
            title: string;
            maxReviewTime: string;
        };
     };
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        personalInfo: {
            title: 'STEP 1: VERIFY YOUR DETAILS',
            subtitle: 'Complete the medical form below<br>to confirm your eligibility.',
            birthDate: 'Date of birth',
        },
        docUpload: {
            uploadDocFirstName: 'Your first name',
            uploadDocLastName: 'Your last name',
            uploadDocOrganization: 'Your organization',
            uploadDocAffiliation: 'Your current affiliation with that organization',
            uploadDocStatus: 'Your medical professional status',
            acceptedTypes: 'No file selected.',
            uploadDocNoFileSelected: 'No file selected.',
            redirectText1: 'If the information shown above is not correct, please click here to enter your information.',
            title: 'Step 2: Upload Documentation',
            subtitle: 'Please upload one of the following forms of documentation to help us verify your current enrollment status. Documentation must have a date within the current term.',
            submitButtonLabel: 'Continue',
            uploadInstructions: 'Important - The document must display: ',
            acceptableExamples: 'Examples of valid documents would be a dated ID card or other issued document that displays your first/last name. Valid formats are: .bmp, .gif, .jpg, .pdf, or .png.',
            uploadDocDocScan: 'NOTE: If your document scan is too fuzzy to read, does not show your full and legal name or shows a name different from the one you are verifying this offer under, you will not be able to finalize the verification process.',
            rejectionReasons: {
                DOCUMENT_UNREADABLE: "The document you submitted was unreadable due to poor image quality. Please make sure you have a clearly legible image that's bright and crisp, and try submitting again.",
                DOCUMENT_PASSWORD_PROTECTED: 'We are unable to accept password protected documents.',
                DOCUMENT_LIKELY_FRAUD: 'The document you submitted is insufficient for establishing eligibility for this offer.',
                DOCUMENT_UNSUPPORTED: 'The document you submitted is not on the list of accepted document types.',
                DOCUMENT_HANDWRITTEN: 'We cannot accept handwritten documents.',
                DOCUMENT_WORD_DOC: 'We cannot accept text copied and pasted from official documents. Please submit a screenshot or image of the official document.',
                MISSING_INFORMATION: 'The document you submitted does not provide all of the information necessary to determine eligibility for this offer.',
                MISSING_INFORMATION_PERSON_NAME: 'The document you submitted is missing a first and/or last name.',
                MISSING_INFORMATION_ORGANIZATION_NAME: 'The document you submitted does not include an organization name that confirms your connection to that organization.',
                DOCUMENT_EXPIRED: 'The document you submitted has expired.',
                DOCUMENT_OUTDATED: 'The document you submitted is missing an issue date or was issued too far in the past.',
                DOCUMENT_OUTDATED_LAST_3_MONTHS: 'The document you submitted is missing an issue date or was issued more than three months ago.',
                DOCUMENT_OUTDATED_LAST_6_MONTHS: 'The document you submitted is missing an issue date or was issued more than six months ago.',
                DOCUMENT_OUTDATED_LAST_12_MONTHS: 'The document you submitted is missing an issue date or was issued more than twelve months ago.',
                MISMATCH_PERSON_NAME: 'The information on the document you submitted does not match the first and/or last name submitted on the verification form.',
                MISMATCH_ORGANIZATION: 'The organization name on the document(s) you submitted does not match the organization you listed on the verification form.',
                MISMATCH_STATUS: 'The status on the document you submitted does not match the status you listed on your verification form.',
                INELIGIBLE_ORGANIZATION: 'The organization on the document you submitted is not eligible for this offer.',
                MISSING_INFORMATION_UNIVERSITY_ENROLLMENT: 'The document you submitted does not prove enrollment in the current term.',
                MISMATCH_SCHOOL_NAME: 'The school name on the document you submitted does not match the school name listed on the verification form.',
                INELIGIBLE_ORGANIZATION_UNIVERSITY_TITLE_IV: 'The school listed on the document you submitted is not eligible for this offer because it is not a Title IV degree-granting college or university in the United States.',
                INELIGIBLE_ORGANIZATION_US_UNIVERSITY: 'The school listed in the document you submitted is not eligible for this offer because it is not in the United States.',
                INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT: 'High School Students are not eligible for this offer.',
                MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES: 'The document you submitted is does not show affiliation to an eligible branch of the United States Armed Forces.',
                MISSING_INFORMATION_AFFILIATION_US_UNIFORMED_SERVICES: 'The document you submitted does not show affiliation to an eligible branch of the United States Uniformed Services.',
                MISMATCH_COMPANY_NAME: 'The company name on the document you submitted does not match the company name you listed on the verification form.',
                PAYSTUB_OUTDATED_LAST_30_DAYS: 'Please upload a paystub that was issued within the last 30 days.',
                PAYSTUB_OUTDATED_LAST_60_DAYS: 'Please upload a paystub that was issued within the last 60 days.',
                MISSING_INFORMATION_BIRTHDATE: 'The document you submitted is missing a birthdate, or your age is ineligible for this offer.',
                MISMATCH_BIRTHDATE: 'The birthdate on the document you submitted does not match the birthdate you listed on the verification form.',
                OTHER_CONTACT_US: 'We are having problems verifying your eligibility for the offer. Please contact SheerID customer service for help: customerservice@sheerid.com',
                PERSON_FIELD_MISMATCH: 'A field in the document provided did not match with what was provided on the verification form.',
            },
        },
        pending: {
            title: 'Step 3: Upload success',
            subtitle: 'Your document has uploaded successfully. The review process has now started. You will be contacted via email in less than 20 minutes with details regarding your verification request.',
            subtitle2: 'Wait here or let us notify you of the outcome.',
            subtitle3: 'NOTE: If you do not receive an email within the time shown above, you may want to check your junk/spam folder for the message which will be sent by verify.sheerID.com. ',
            maxReviewTime: '20 minutes',
        },
        success: {
            returnTo: "<a href='https://factory.jcrew.com' target='_blank' class='sid-jcrew-link'>Shop now</a>",
            useDiscount: "To make sure you have every opportunity to use your discount, we're also emailing you a copy of your code and a link to the <a href='https://factory.jcrew.com' target='_blank' class='sid-jcrew-link'>factory.jcrew.com</a> website so that you can shop now, or shop later. Please check for an email from us (verify@sheerid.com) for all the details.",
            title: 'STEP 2: SUCCESS',
            subtitle: "Thanks for confirming your medical status. <br><br>Just use this code at checkout to receive your discount at <a href='https://factory.jcrew.com' target='_blank' class='sid-jcrew-link'>factory.jcrew.com</a>.*",
            redirectUrl: null,
            redirectButtonText: 'Continue',
            emailNotification: 'We have emailed you a copy so you can use your new code now or later. Look for an email from verify@sheerid.com',
            footerThree: 'Just use this code at checkout to receive your discount at J.Crew Factory stores and at factory.jcrew.com. Not valid in J.Crew stores; at jcrew.com; or on phone orders. Offer cannot be applied to previous purchases or the purchase of gift cards and cannot be redeemed for cash. Exclusions apply; see a store associate or the link in the top banner at factory.jcrew.com for an up-to-date list. To redeem in stores, present a valid medical ID at checkout. To redeem online, enter the unique code provided in the promo code box at online checkout. Offer valid in the U.S. only.',
        },
        error: {
            errorId: {
                verificationLimitExceeded: {
                    title: 'ALREADY REDEEMED',
                },
            },
        },
    },
    errorId: {
        internalServerError: 'Internal server error',
        noProgram: 'No program found',
        noVerification: 'No verification found',
        invalidProgram: 'Invalid program',
        invalidStep: 'Invalid step',
        invalidMilitaryStatus: 'Invalid military status, expected one of [ACTIVE_DUTY, VETERAN, RESERVIST, MILITARY_RETIREE]',
        invalidFirstResponderStatus: 'Invalid first responder status, expected one of [POLICE, EMT, FIREFIGHTER]',
        invalidOrganization: 'You must select an organization from the list',
        invalidFirstName: 'Invalid first name',
        invalidLastName: 'Invalid last name',
        invalidBirthDate: 'Invalid birth date',
        invalidEmail: 'Invalid email',
        invalidPostalCode: 'Invalid postal code',
        underagePerson: 'Underage',
        outsideAgePerson: 'Age outside allowed range',
        futureBirthDate: 'Future birthdate',
        unsupportedDocMimeType: 'One or more files is an unsupported format',
        invalidFileSizeEmpty: 'One or more files is empty',
        invalidFileSizeMax: 'One or more files is too large (max: 10MB)',
        invalidNumberOfFiles: 'Maximum number of files exceeded (max: 5)',
        invalidDocUploadToken: 'Provided document upload token is not valid',
        verificationLimitExceeded: 'Verification limit exceeded',
        docReviewLimitExceeded: 'Document review limit exceeded',
        maxMetadataValuesExceeded: 'Maximum number of metadata values exceeded',
        maxMetadataLengthExceeded: 'Maximum length of metadata value exceeded',
        unknownError: 'Unknown Error',
        invalidRequest: 'Invalid request',
        invalidApiToken: 'Provided API token was invalid or empty',
        simulatedError: 'This is a simulated error',
        notFound: 'Not found',
    },
    requiredFields: 'All fields are required',
    jcrewPrivacyPolicy: "To view our Privacy Policy <a href='https://factory.jcrew.com/help/privacy-policy' target='_blank' class='sid-privacy-link'>click here</a>",
    optIn: 'I would like to receive marketing communications, including email, from J.Crew and its family of brands.',
    firstResponderInfoShared: 'Information entered into this web form will be used for verification purposes. The information will be shared with J.Crew.',
    verifyMyMedicalProfessionalStatus: 'VERIFY AND CONTINUE',
    organizationPlaceholder: '',
    footerOne: "<a href='https://verify.sheerid.com/medical-faq/' target='_blank' class='sid-footer-two'>SheerID FAQs</a> &nbsp;",
    footerTwo: "<a href='https://factory.jcrew.com/help/privacy-policy' target='_blank' class='sid-footer-two'>J.Crew Factory Privacy Policy</a>",
    lastFooter: 'Verification services hosted by SheerID.',
    getHelp: 'SheerID FAQs',
};
